module.exports = __webpack_public_path__ + "assets/img/ic-instruction.c530f4fe.svg";